import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UploadedProduct, FileUploadResponse, FileDetailsResponse } from '@/types/fileUpload';

interface FileUploadState {
  isUploading: boolean;
  uploadError: string | null;
  uploadedFileId: string | null;
  fileDetails: FileDetailsResponse | null;
  isLoadingDetails: boolean;
  detailsError: string | null;
}

const initialState: FileUploadState = {
  isUploading: false,
  uploadError: null,
  uploadedFileId: null,
  fileDetails: null,
  isLoadingDetails: false,
  detailsError: null,
};

const fileUploadSlice = createSlice({
  name: 'fileUpload',
  initialState,
  reducers: {
    uploadFileRequest: (state, action: PayloadAction<UploadedProduct[]>) => {
      state.isUploading = true;
      state.uploadError = null;
    },
    uploadFileSuccess: (state, action: PayloadAction<FileUploadResponse>) => {
      state.isUploading = false;
      state.uploadedFileId = action.payload.id;
    },
    uploadFileFailure: (state, action: PayloadAction<string>) => {
      state.isUploading = false;
      state.uploadError = action.payload;
    },
    getFileDetailsRequest: (state, action: PayloadAction<string>) => {
      state.isLoadingDetails = true;
      state.detailsError = null;
    },
    getFileDetailsSuccess: (state, action: PayloadAction<FileDetailsResponse>) => {
      state.isLoadingDetails = false;
      state.fileDetails = action.payload;
    },
    getFileDetailsFailure: (state, action: PayloadAction<string>) => {
      state.isLoadingDetails = false;
      state.detailsError = action.payload;
    },
  },
});

export const {
  uploadFileRequest,
  uploadFileSuccess,
  uploadFileFailure,
  getFileDetailsRequest,
  getFileDetailsSuccess,
  getFileDetailsFailure,
} = fileUploadSlice.actions;

export default fileUploadSlice.reducer;